import { combineReducers } from 'redux'
import homeReducer, { HomeState } from './home.reducer'
import aboutReducer, { AboutState } from './about.reducer'
import departmentReducer, { DepartmentState } from './department.reducer'
import newsReducer, { NewsState } from './news.reducer'
import teamReducer, { TeamState } from './team.reducer'
import contactReducer, { ContactState } from './contact.reducer'
import supportReducer, { SupportState } from './support.reducer'

const rootReducer = combineReducers({
  home: homeReducer,
  about: aboutReducer,
  department: departmentReducer,
  news: newsReducer,
  team: teamReducer,
  contact: contactReducer,
  support: supportReducer,
})

export type RootState = {
  home: HomeState
  about: AboutState
  department: DepartmentState
  news: NewsState
  team: TeamState
  contact: ContactState
  support: SupportState
}

export default rootReducer
